import React, {PureComponent} from 'react';
import Modal from '../../components/modal/modal';
import Button from '../../components/button/button';
import {deleteProject} from '../../api/project';
import {shareSave} from '../../api/share';
import message from '../../components/message/message';
import {headNavBack} from '../../lib/utils'

class ProjectsDeleteModal extends PureComponent {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit() {
    if (this.props.projectType === 'myshare') {
      shareSave({
        id: this.props.deleteId,
        is_public: 0
      }, {quiet: true}).then(res => {
        if (res === '更新成功') {
          !this.props.content&&message.show('删除成功');
          this.props.content && message.show('已取消分享');
          setTimeout(() => {
            this.props.onClose();
            headNavBack(this.props.history);
          }, 500)
        }
      })
    } else if (this.props.projectType === 'mine') {
      deleteProject({id: this.props.deleteId}, {quiet: true}).then(res => {
        if (res) {
          this.props.onClose()
          message.show(res)
        }
      }).catch(error => {
        if (error.msg || error.message) {
          message.show(error.msg || error.message);
        } else {
          message.show(error.toString());
        }
      })

    }
  }
  render() {
    return (
      <Modal onClose={this.props.onClose} title={this.props.title?this.props.title:'删除作品'} size={this.props.size ? this.props.size : 'normal'}>
        <p
          style={{
            width: '100%',
            textAlign: 'center',
            color: '#5391E4',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '40px',
            marginBottom: '40px'
          }}
        >
          { this.props.content? this.props.content : '是否删除当前作品？'}
        </p>
        <div style={{textAlign: 'center'}}>
          <Button
            style={{marginRight: '20px'}}
            theme={'submit'}
            label='确定'
            onClick={this.handleSubmit}
          />
          <Button
            label='取消'
            onClick={this.props.onClose}
          />
        </div>
      </Modal>
    )
  }
}

// const mapStateToProps = () => {
//   return
// }

// const mapDispatchToProps = dispatch => ({
//   setMyProjects: projects => dispatch(setMyProjects(projects))
// })

// export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDeleteModal)
export default ProjectsDeleteModal
